import React, { Component, Fragment } from 'react'
import { Container,Row,Col, Button } from 'react-bootstrap'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';
import Product1 from '../../assets/images/product/parkease1.png'






class ProductDetails extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
               <div className="breadbody">
                <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to="/products"> Product </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/parkease">Parkease</Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>

          <div className="d-flex justify-content-between align-items-center mb-2">
          <h2 className="section-title text-primary m-0"></h2>

      
        <Link to="/parking">
            
            
       
          <Button size="sm" variant="primary">
               Live Demo
          </Button>
          </Link>
      
          </div>


               <h2 className="section-title text-center mb-2 text-primary"><strong>PARKEASE</strong></h2>
   

               <p className="text-center mb-3">Parking and Management system</p>
                   <Row className="p-2">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>


         <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>


          <Container  className="my-3">
              
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
          <h5 className="Product-Name">PARKEASE</h5>
          
          <p>ParkEase is a modern parking management system designed to simplify and ease daily parking operations for business owners. It enables attendants to quickly register vehicles, select customer services, and generate invoices, while automatically producing receipts when vehicles exit. With a real-time dashboard, administrators can monitor active vehicles, total entries, and overall revenue, as well as manage service pricing. By replacing manual processes with a fast, accurate,
           and professional digital solution, ParkEase improves efficiency, reduces errors, and enhances the overall customer experience</p>
          <div className="">
           <h6> ParkEase has two main types of users:</h6>
          <p>
               Admin (Administrator)
               Parking Attendant</p>

               <h6>Login to the System</h6>
              <p className="login-steps">
               Open the system in your browser,
               Enter your username/email,
               Enter your password,
               Click Login
               </p>


               <h4>Admin Guide</h4>
          <p>After logging in, the admin can view:Total number of vehicles entered Number of active vehicles in parking
               Total revenue/charges collected</p>
               <h5>Manage Services</h5>
               <p>Add new services (e.g., Parking, Car Wash)Set or update service pricesDelete or edit existing services</p>
               <h5>Monitor Operations</h5>
          <p>View all registered vehicles, Track vehicles currently in parking, View completed transactions</p>


          </div>


          <div className="">
               <h4>Parking Attendant Guide</h4>
               <p>Click “Register Vehicle” Enter vehicle details (e.g., plate number) Select services requested by the customer, Click Submit</p>
          </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">MORE DETAILS</h6>
          <h6 className="section-sub-title">ParkEase is a parking management system designed to help manage vehicle entry, services, billing, and reporting. It improves efficiency, accuracy, and control over parking operations.</h6>
          <p>After registration, the system generates an invoice, Click Print Invoice to give it to the customer</p>
          <p>Locate the vehicle in the system, Confirm services completed, Click Exit Vehicle, System generates a receipt, Click Print Receipt</p>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">REVIEWS</h6>
          <p className=" p-0 m-0"><span className="Review-Title"> Efficient and Easy to Use</span>  </p>
          <p>“ParkEase has completely transformed how we manage our parking operations. Registering vehicles and generating invoices is now fast and error-free. Highly recommended for any parking business.”
</p>

          <p className=" p-0 m-0"><span className="Review-Title">Improved Our Revenue Tracking</span> </p>
          <p>“Before ParkEase, it was difficult to track daily income. Now, the dashboard clearly shows all transactions and total revenue. It has improved our financial control.”</p>

          <p className=" p-0 m-0"><span className="Review-Title">Professional and reliable</span> </p>
          <p>Printing invoices and receipts gives our business a professional image. Customers trust us more.</p>

          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default ProductDetails